<div *ngIf="isOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div id="modal-content" tabindex="-1" class="bg-white rounded shadow-lg w-full sm:max-w-lg max-w-[80vw] outline-none focus:outline-none relative" role="dialog" aria-modal="true">
    <!-- Botão fechar -->
    <button type="button" (click)="onCancel()" class="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-xl font-bold focus:outline-none" aria-label="Fechar">&times;</button>
    <!-- Header -->
    <div class="p-4 border-b border-gray-200 text-center px-10" *ngIf="modalHeaderTpl || header">
      <ng-container *ngIf="modalHeaderTpl; else headerText">
        <ng-container *ngTemplateOutlet="modalHeaderTpl"></ng-container>
      </ng-container>
      <ng-template #headerText>
        <span class="text-2xl font-bold text-red-600">{{ header }}</span>
      </ng-template>
    </div>
    <!-- Body -->
    <div class="p-4 text-center" *ngIf="modalBodyTpl || body">
      <ng-container *ngIf="modalBodyTpl; else bodyText">
        <ng-container *ngTemplateOutlet="modalBodyTpl"></ng-container>
      </ng-container>
      <ng-template #bodyText>
        <span [innerHTML]="body"></span>
      </ng-template>
    </div>
    <!-- Footer -->
    <div class="p-4 border-t border-gray-200 flex justify-center gap-4">
      <ng-container *ngIf="modalFooterTpl; else defaultFooter">
        <ng-container *ngTemplateOutlet="modalFooterTpl"></ng-container>
      </ng-container>
      <ng-template #defaultFooter>
        <button type="button" (click)="onConfirm()" [ngClass]="confirmColor === 'success' ? 'bg-green-600 text-white border-green-600 hover:bg-green-700' : 'bg-red-600 text-white border-red-600 hover:bg-red-700'" class="btn px-6 py-2 rounded border font-semibold">
          {{ confirmText }}
        </button>
        <button type="button" (click)="onCancel()" [ngClass]="cancelColor === 'danger' ? 'border-red-600 text-red-600 hover:bg-red-50' : 'border-green-600 text-green-600 hover:bg-green-50'" class="btn px-6 py-2 rounded border font-semibold bg-white">
          {{ cancelText }}
        </button>
      </ng-template>
    </div>
  </div>
</div>
